<div>
  <div class="loader-bg col-12" *ngIf="showLoader">
    <span class="loader"><span class="loader-inner"></span></span>
  </div>

  <div class="modal-header col-12">
    <img title="Close Modal" (click)="closeModal()" width="17" height="17" src="assets/images/cross-dark-grey.svg">
  </div>
  <div class="modal-body">
    <h2 class="modal-title col-12">Create Account</h2>

    <p class="error-message" *ngIf="showErrorMsg">{{showMsg}}</p>

    <form class="form-bg col-12" [formGroup]="signupForm">
      <div class="form-group names-class">
        <div class="col-6 pl-0">
          <label for="firstName">First Name</label>
          <input type="text" class="form-control" id="firstName" required formControlName="firstName" autocomplete="off">
        </div>
        <div class="col-6 pr-0">
          <label for="lastName">Last Name</label>
          <input type="text" class="form-control" id="lastName"  required formControlName="lastName" autocomplete="off">
        </div>
      </div>

      <div class="form-group">
        <label for="email">Your Email</label>
        <input type="email" name="email" class="form-control" #email required id="email" formControlName="email" autocomplete="off" (blur)="emailValidation()" (focus)="showEmailError = false;">
        <small *ngIf="signupForm.get('email').invalid && (signupForm.get('email').dirty || signupForm.get('email').touched)" class="error-text-color">
          <span *ngIf="signupForm.controls['email'].errors.required">
            Email is required.
          </span>
        </small>
        <small *ngIf="showEmailError" class="error-text-color">
          Invalid email address.
        </small>
      </div>

      <div class="form-group">
        <label for="password" [ngClass]="{'labelColorRed' : showPasswordError && (!oneLetter || !specialNumeric || !minCharacterCheck)}">Password</label>
        <input type="password" name="password" class="form-control" #password required id="password"
               minlength="8" maxlength="20" formControlName="password" autocomplete="off"
               [ngClass]="{'inputRedBorder' : showPasswordError && (!oneLetter || !specialNumeric || !minCharacterCheck)}">
        <!--<small class="width-100 float-left mt-1">-->
          <!--<small class="width-25 float-left" style="color: rgba(0, 0, 0, 0.5);">-->
          <!--<i class="fa" aria-hidden="true" *ngIf="!oneLetter" style="width: 10px;"></i>-->
          <!--<i class="fa fa-check" aria-hidden="true" *ngIf="oneLetter" style="color: #86B02D;"></i>-->
          <!--One Letter-->
          <!--</small>-->
          <!--<small class="width-25 float-left" style="color: rgba(0, 0, 0, 0.5);">-->
            <!--<i class="fa" aria-hidden="true" *ngIf="!upperCase" style="width: 10px;"></i>-->
            <!--<i class="fa fa-check" aria-hidden="true" *ngIf="upperCase" style="color: #86B02D;"></i>-->
            <!--Uppercase-->
          <!--</small>-->
          <!--<small class="width-25 float-left" style="color: rgba(0, 0, 0, 0.5);">-->
            <!--<i class="fa" aria-hidden="true" *ngIf="!lowerCase" style="width: 10px;;"></i>-->
            <!--<i class="fa fa-check" aria-hidden="true" *ngIf="lowerCase" style="color: #86B02D;"></i>-->
            <!--Lowercase-->
          <!--</small>-->
          <!--<small class="width-25 float-left" style="color: rgba(0, 0, 0, 0.5);">-->
            <!--<i class="fa" aria-hidden="true" *ngIf="!specialNumeric" style="width: 10px;;"></i>-->
            <!--<i class="fa fa-check" aria-hidden="true" *ngIf="specialNumeric" style="color: #86B02D;"></i>-->
            <!--Number/Special-->
          <!--</small>-->
          <!--<small class="width-25 float-left" style="color: rgba(0, 0, 0, 0.5);">-->
            <!--<i class="fa" aria-hidden="true" *ngIf="!minCharacterCheck" style="width: 10px;;"></i>-->
            <!--<i class="fa fa-check" aria-hidden="true" *ngIf="minCharacterCheck" style="color: #86B02D;"></i>-->
            <!--8 or More-->
          <!--</small>-->
        <!--</small>-->
        <small *ngIf="signupForm.controls['password'].invalid && (signupForm.controls['password'].dirty || signupForm.controls['password'].touched)"
               class="error-text-color width-100 float-left mt-1">
          <span *ngIf="signupForm.controls['password'].errors.required">
            Password is required.
          </span>
        </small>
      </div>

      <div class="form-group mt-4">
        <label for="pwdAgain" [ngClass]="{'labelColorRed' : showPasswordError && (!oneLetter || !specialNumeric || !minCharacterCheck)}">Confirm Password</label>
        <input type="password" name="pwdAgain" class="form-control" #pwdAgain required id="pwdAgain" minlength="8" maxlength="20" formControlName="pwdAgain"
               (blur)="onPwdChange($event.target.value)" autocomplete="off"
               [ngClass]="{'inputRedBorder' : showPasswordError && (!oneLetter || !specialNumeric || !minCharacterCheck)}">
        <small *ngIf="signupForm.controls['pwdAgain'].dirty || signupForm.controls['pwdAgain'].touched" class="error-text-color">
         <span *ngIf="signupForm.controls['pwdAgain'].required">
            Confirm password is required.
          </span>
          <span *ngIf="signupForm.controls['password'].value !== signupForm.controls['pwdAgain'].value">
            Password does not match.
          </span>
        </small>
      </div>

      <p class="passwordError" *ngIf="showPasswordError && (!oneLetter || !specialNumeric || !minCharacterCheck)">
        Password must be a minimum of 8 characters with at least 1 number or 1 special character.
      </p>

      <div class="form-group">
        <label for="heardBy">How did you hear about us?</label>
        <select class="form-control" id="heardBy" formControlName="heardBy" required (change)="hearAboutUsChange()">
            <option value="" disabled selected>Select One</option>
            <option *ngFor="let item of aboutList" [ngValue]="item" >{{ item }}</option>
        </select>
      </div>

      <div class="form-group" [hidden]="!showOtherField">
        <label for="other">Please Specify</label>
        <input type="text" name="other" class="form-control" #other id="other" formControlName="other" maxlength="20" (keyup)="hearAboutUsValidation()" autocomplete="off">
      </div>

      <div class="btn-bg mt-5">
        <button type="submit"  class="btn-green col-10" (click)="signupFun()"
                [disabled]="signupForm.invalid || !minCharacterCheck || !oneLetter || !specialNumeric || signupForm.controls['password'].value !== signupForm.controls['pwdAgain'].value || otherFieldButtonDisable"
                [ngClass]="{'btn-green-disabled' : signupForm.invalid || !minCharacterCheck || !oneLetter || !specialNumeric || signupForm.controls['password'].value !== signupForm.controls['pwdAgain'].value || otherFieldButtonDisable}">CREATE ACCOUNT</button>
      </div>
    </form>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/modules/user/auth/signup/signup.component.html